import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Accordion } from '../../accordion';
import { FlexBox } from '../../box';
import { ButtonBase } from '../../button';
import { IconArrowDropDown } from '../../icon';
import { styled } from '../../styled';
import { TypographyWithTooltip } from '../../typography';
import { itemBackground } from '../shared';
const SUB_NAVIGATION_ITEM_HEIGHT = 36;
const SectionCaret = styled(IconArrowDropDown)(({ theme }) => ({
    fontSize: theme.spacing(2)
}));
const SubNavItemImpl = (props) => {
    const { item } = props;
    const hasChildren = Boolean(item.children?.length);
    const selected = Boolean(item.selected);
    if (hasChildren) {
        return (_jsx(Accordion, { hideDivider: true, expanded: props.expanded, slotProps: { transition: { appear: false } }, summary: {
                expandIcon: _jsx(SectionCaret, {}),
                slotProps: {
                    root: {
                        sx: {
                            px: 1,
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: itemBackground('hover')
                            },
                            '& .accordion-item': { pr: 1 }
                        }
                    }
                },
                primary: (_jsxs(FlexBox, { hAlign: "space-between", vAlign: "center", width: "100%", gap: 1, children: [_jsx(FlexBox, { autoShrink: true, minWidth: 0, children: _jsx(TypographyWithTooltip, { fontWeight: 400, color: "text.primary", lineClamp: 2, children: item.label }) }), item.badge] })),
                selected: false
            }, details: {
                sx: {
                    p: 0,
                    '> div > .MuiButtonBase-root': {
                        mb: 0.5,
                        mx: 0,
                        px: 2,
                        '&:first-of-type': { mt: 0.5 },
                        '&:last-of-type': { mb: 0 }
                    }
                }
            }, sx: {
                backgroundColor: 'transparent',
                '&.MuiAccordion-root:before': { display: 'none' },
                '& .MuiAccordionSummary-root': {
                    minHeight: SUB_NAVIGATION_ITEM_HEIGHT,
                    '&.Mui-expanded': {
                        minHeight: SUB_NAVIGATION_ITEM_HEIGHT
                    }
                },
                '& .MuiAccordionSummary-content': {
                    minWidth: 0,
                    margin: 0,
                    '&.Mui-expanded': { my: 0 }
                }
            }, onExpandedChange: (expanded) => props.onExpandedChange?.(item.id, expanded), children: item.children.map((child) => (_jsx(SubNavItem, { depth: (props.depth ?? 0) + 1, expanded: Boolean(props.expandedIds?.includes(child.id) ||
                    child.selected), expandedIds: props.expandedIds, item: child, onExpandedChange: props.onExpandedChange }, child.id))) }));
    }
    return (_jsx(ButtonBase, { "aria-current": selected ? 'page' : undefined, disabled: item.disabled, onClick: () => item.onClick?.(item.value), "data-role": "navigation-sub-nav-item", sx: {
            width: '100%',
            minHeight: SUB_NAVIGATION_ITEM_HEIGHT,
            justifyContent: 'flex-start',
            p: 1,
            pl: props.depth ? 2 : 1,
            borderRadius: 1,
            backgroundColor: itemBackground(selected ? 'selected' : 'default'),
            '&:hover': {
                backgroundColor: selected
                    ? undefined
                    : itemBackground('hover')
            },
            '&:focus-visible': {
                backgroundColor: itemBackground('focus')
            }
        }, children: _jsxs(FlexBox, { hAlign: "space-between", vAlign: "center", width: "100%", gap: 1, children: [_jsx(FlexBox, { autoShrink: true, minWidth: 0, children: _jsx(TypographyWithTooltip, { fontWeight: selected ? 500 : undefined, color: selected ? 'primary.main' : 'text.secondary', lineClamp: 2, children: item.label }) }), item.badge] }) }));
};
export const SubNavItem = SubNavItemImpl;
const SubNavImpl = (props) => {
    const [localExpandedIds, setLocalExpandedIds] = React.useState([]);
    const expandedIds = props.expandedIds ?? localExpandedIds;
    const onExpandedChange = (id, expanded) => {
        if (props.expandedIds === undefined) {
            setLocalExpandedIds((currentIds) => expanded
                ? Array.from(new Set([...currentIds, id]))
                : currentIds.filter((currentId) => currentId !== id));
        }
        props.onExpandedChange?.(id, expanded);
    };
    return (_jsx(FlexBox, { stack: true, gap: 0.5, children: props.items.map((item) => (_jsx(SubNavItem, { expanded: expandedIds.includes(item.id) || item.selected, expandedIds: expandedIds, item: item, onExpandedChange: onExpandedChange }, item.id))) }));
};
export const SubNav = SubNavImpl;
